import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.maps.GooglePlaceAutocomplete.';
  public static readonly mapLocationsTooltip = `${Id.prefix}mapLocationsTooltip`;
  public static readonly choosePlace = `${Id.prefix}choosePlace`;
  public static readonly quickFind = `${Id.prefix}quickFind`;
}

export class LangGooglePlaceAutocomplete {
  private constructor() {}
  public static mapLocationsTooltip(): string {
    return interpolate(Id.mapLocationsTooltip);
  }
  public static choosePlace(): string {
    return interpolate(Id.choosePlace);
  }
  public static quickFind(): string {
    return interpolate(Id.quickFind);
  }
}

export class GooglePlaceAutocompleteModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.mapLocationsTooltip,
      'Map Locations will only display when using this lookup field, and will not display using manual address entry',
      'Tooltip for map locations display behavior'
    );
    register.add(Id.choosePlace, 'Choose Place', 'Label for place autocomplete input');
    register.add(Id.quickFind, 'Quick Find', 'Placeholder for place autocomplete input');
  }
}
